import React from 'react'
import { WHATSAPP_NUMBER, WHATSAPP_DISPLAY } from '@constants/contact'
import { LuMapPin, LuPhone, LuMail } from 'react-icons/lu'
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaYoutube } from 'react-icons/fa'
import Logo from '@resources/imgs/logo-proseed.webp'
import './FooterSection.css'

const socialLinks = [
  { icon: FaFacebookF, href: 'https://www.facebook.com/proseedbanco', label: 'Facebook' },
  { icon: FaInstagram, href: 'https://www.instagram.com/proseed_brasil/', label: 'Instagram' },
  { icon: FaLinkedinIn, href: 'https://www.linkedin.com/company/pro-seed-banco-de-s%C3%AAmen/', label: 'LinkedIn' },
  { icon: FaYoutube, href: 'https://www.youtube.com/channel/UCZX0Myb-zJc4p93I4ewTMRw', label: 'YouTube' },
]

const quickLinks = [
  { label: 'Catálogo de Doadores', href: '/' },
  { label: 'Meus Pedidos', href: '/meus-pedidos' },
  { label: 'Minha Conta', href: '/minha-conta' },
]

const FooterSection: React.FC = () => {
  return (
    <footer className="homeuser-footer bg-white" style={{ borderRadius: 20, boxShadow: '0 1px 8px rgba(0,0,0,0.07)' }}>
      <div className="p-4 p-md-5">
        <div className="row">
          {/* Brand */}
          <div className="col-12 col-md-4 mb-4 mb-md-0">
            <div className="d-flex align-items-center mb-3">
              <img src={Logo} alt="Pro-Seed" style={{ height: 36 }} />
            </div>
            <p className="homeuser-footer-desc text-muted mb-4">
              Banco de sêmen preferencial de clínicas e médicos em todo o Brasil. Há décadas realizando sonhos e construindo famílias!
            </p>
            <div className="d-flex" style={{ gap: 8 }}>
              {socialLinks.map(({ icon: Icon, href, label }) => (
                <a key={label} href={href} target="_blank" rel="noreferrer" aria-label={label}
                  className="homeuser-footer-social-icon d-flex align-items-center justify-content-center"
                >
                  <Icon size={15} />
                </a>
              ))}
            </div>
          </div>

          {/* Quick links */}
          <div className="col-12 col-sm-6 col-md-2 offset-md-2 mb-4 mb-md-0">
            <p className="homeuser-footer-heading font-weight-bold text-uppercase mb-3" style={{ color: '#FA5A84' }}>
              Navegação
            </p>
            <ul className="list-unstyled mb-0" style={{ lineHeight: 2.2 }}>
              {quickLinks.map(({ label, href }) => (
                <li key={href}>
                  <a href={href} className="homeuser-footer-link">{label}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="col-12 col-sm-6 col-md-4 mb-4 mb-md-0">
            <p className="homeuser-footer-heading font-weight-bold text-uppercase mb-3" style={{ color: '#FA5A84' }}>
              Contato
            </p>
            <ul className="list-unstyled mb-0" style={{ lineHeight: 2.2 }}>
              <li className="d-flex align-items-center">
                <LuMapPin size={14} className="mr-2 flex-shrink-0 text-muted" style={{ marginTop: 5 }} />
                <span className="homeuser-footer-link" style={{ lineHeight: 1.4 }}>Rua Peixoto Gomide, 515 - Jardim Paulista<br />São Paulo - SP, 01409-001</span>
              </li>
              <li className="d-flex align-items-center">
                <LuPhone size={14} className="mr-2 flex-shrink-0 text-muted" />
                <a href={`https://wa.me/${WHATSAPP_NUMBER}`} className="homeuser-footer-link">{WHATSAPP_DISPLAY}</a>
              </li>
              <li className="d-flex align-items-center">
                <LuMail size={14} className="mr-2 flex-shrink-0 text-muted" />
                <a href="mailto:reservas@pro-seed.com.br" className="homeuser-footer-link">reservas@pro-seed.com.br</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Copyright bar */}
      <div className="px-4 px-md-5 py-3" style={{ borderTop: '1px solid #F3F4F6' }}>
        <p className="homeuser-footer-copyright text-muted text-center mb-0">
          © {new Date().getFullYear()} PRO-SEED | Banco de Sêmen — Todos os Direitos Reservados | Desenvolvido por <a href="https://nextgti.com.br/" target="_blank" rel="noopener noreferrer">NextGTI</a>
        </p>
      </div>
    </footer>
  )
}

export default FooterSection
